define('modules/form_editor/views/preview_base',['require','exports','module','lib/util','base/itemview','../behaviours/has_toolbar','../behaviours/has_error_message','../../editor/models/editorstate','ldsh!../templates/input_text'],function(require, exports, module){
  "use strict";
  var util = require("lib/util"),
      ItemView = require("base/itemview"),
      HasToolbar = require("../behaviours/has_toolbar"),
      HasErrorMessage = require("../behaviours/has_error_message");

  /* Sure there is a better way to do this, but it means refactor */
  var EditorState = require("../../editor/models/editorstate");

  var getAMPStateId = function() {
    var randomId = util.generateRandom() + util.generateRandom();
    return 'ampStateId' + randomId;
  };

  module.exports = ItemView.extend({
    template: require("ldsh!../templates/input_text"),
    className: "form-group ed-panel-item form-group-col",

    events: {
      "click": "onClick"
    },

    initialize: function(options) {
      this.vent = options.parent.vent;
      this.activeItem = options.parent.activeItem;

      this.listenTo(this.model, "item:selected", _.bind(function(selected){
        this.$el.toggleClass("item-is-edited", selected);
      }, this));

      if (EditorState.getAMPState()) {
        this.model.set('ampStateId', getAMPStateId());
      }
    },

    onClick: function(e) {
      if(this.activeItem.get("item") !== this.model){
        this.trigger("item:select", this);
      }
      this.$el.blur();
      e.preventDefault();
    },

    onRender: function() {
      this.$el.toggleClass("ed-is-required", this.model.get("isRequired"));
      this.$el.removeClass(this.model.previous("widthClass"));
      this.$el.addClass(this.model.get("widthClass"));
      //why this? because setting a model attribute to the same
      //value doesn't trigger any change event. When reordering
      //we need this to mark the view as selected again
      var meSelected = (this.activeItem.get("item") === this.model);
      this.model.trigger("item:selected", meSelected);
    },

    localize: function(translationKey) {
      try {
        var defaultsModel = EditorState.getVariant().getPropertyGroup("page:defaults"),
            lang = defaultsModel.get("language");
        if (translationKey) translationKey += ("_" + lang);
      } catch(e) {}
      return $.i18n.t(translationKey);
    },

    helpers: function() {
      return {
        isAMP: EditorState.getAMPState(),
        ampStateId: this.model.get("ampStateId")
      };
    }
  });

  util.mixin(module.exports, HasToolbar);
  util.mixin(module.exports, HasErrorMessage);
});

